/** Road traffic / obstacle sprites (top-down, front at top). */
export type TrafficAsset = {
  key: string;
  path: string;
  /** Display scale in GameScene */
  scale: number;
};

export const TRAFFIC_ASSETS: TrafficAsset[] = [
  { key: 'car-red', path: 'assets/traffic/sedan-red.png', scale: 0.68 },
  { key: 'car-blue', path: 'assets/traffic/sedan-blue.png', scale: 0.68 },
  { key: 'car-yellow', path: 'assets/traffic/sedan-yellow.png', scale: 0.68 },
  { key: 'car-suv', path: 'assets/traffic/suv-grey.png', scale: 0.62 },
  { key: 'car-probox', path: 'assets/traffic/probox.png', scale: 0.66 },
  { key: 'car-pickup', path: 'assets/traffic/pickup.png', scale: 0.64 },
  { key: 'rival-matatu', path: 'assets/traffic/rival-matatu.png', scale: 0.55 },
  { key: 'truck', path: 'assets/traffic/truck.png', scale: 0.58 },
  { key: 'boda', path: 'assets/traffic/boda.png', scale: 0.78 },
];

export const TRAFFIC_SCALE: Record<string, number> = Object.fromEntries(
  TRAFFIC_ASSETS.map((a) => [a.key, a.scale]),
);
